module.exports = __webpack_public_path__ + "static/media/onthehill-productions.af41f1d2.png";